import type * as Pricing from '@/pricing/types';

import { Row } from '../Row/Row';

import styles from './Section.module.scss';

interface Props {
    section: string;
    rows: Pricing.Row[];
    options: string[];
}

export function Section({ section, rows, options }: Props) {
    return (
        <div id={`block-pricing-${section}`}>
            <div className={styles.sectionHeader}>
                <div className={styles.sectionLabel}>{section}</div>
                <div className={styles.fill}>
                    <div className={styles.space} />
                    <div className={styles.space}>
                        <div className={styles.grey} />
                    </div>
                </div>
            </div>

            {rows.map((row, i) => (
                <Row key={i} row={row} options={options} />
            ))}
        </div>
    );
}
